export default (percent: string): string => `${percent}%`;
